import './statusBar.scss';
import { getRequired, create, createDiv } from '../core/domMan';

export const wrapperName = 'statusBarWrapper';
export const identifier = 'statusBar';

export default (owner) => {
    let statusBar = document.getElementById(identifier);
    let center;
    var countdown;
    if (statusBar) {
        countdown = getRequired(`${identifier}-status`);
        center = getRequired(`${identifier}-center`);

    } else {
        owner = owner ?? getRequired(wrapperName);
        statusBar = createDiv(owner, { id: identifier, className: 'grid grid-cols-2 sm:grid-cols-1 md:grid-cols-3 gap-1 md:gap-0.5 items-end p-1' });
        const leftCorner = createDiv(statusBar, { id: `${identifier}-leftcorner` });
        center = createDiv(statusBar, { id: `${identifier}-center` });
        const rightCorner = createDiv(statusBar, { id: `${identifier}-rightcorner` });
        countdown = create(leftCorner, 'h3', { id: 'statusBar-status', innerHTML: 'Loading...' });
    }

    return {
        element: countdown, setStatus: text => {
            const old = countdown.innerHTML;
            if (text != old)
                countdown.innerHTML = text;
        }, center
    };
}
